"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RFPSkuQuery = exports.RFPSkuUpdate = exports.RFPSkuCreate = exports.RFPSkuTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const meta_data_1 = require("../common/meta-data");
const ServiceType_1 = require("./ServiceType");
const rfp_sku_extra_1 = require("./rfp-sku-extra");
exports.RFPSkuTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    rfpID: typebox_1.Type.String({ format: 'uuid' }),
    quantity: typebox_1.Type.Number(),
    rfpSkuExtras: typebox_1.Type.Optional(typebox_1.Type.Array(rfp_sku_extra_1.RFPSkuExtraTransport)),
    vendorResponseID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    serviceType: typebox_1.Type.Pick(ServiceType_1.ServiceType, ['id', 'name']),
    /**
     * Make sure it's in cents. amount is only for hauler responses or the winning bid on rfp
     */
    unitPrice: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    totalPrice: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    billingFrequency: typebox_1.Type.Optional(common_1.Duration),
    serviceFrequency: typebox_1.Type.Optional(common_1.Duration),
    serviceCycleLength: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    noteToVendor: typebox_1.Type.Optional(typebox_1.Type.String()),
    noteFromVendor: typebox_1.Type.Optional(typebox_1.Type.String()),
    // serviceDays: Type.Optional(), // TODO setup serviceDays
    metadata: meta_data_1.MetaData,
});
exports.RFPSkuCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.RFPSkuTransport, ['id', 'metadata', 'totalPrice', 'rfpSkuExtras', 'serviceType']),
    typebox_1.Type.Object({
        rfpSkuExtras: typebox_1.Type.Array(rfp_sku_extra_1.RFPSkuExtraCreate),
        serviceTypeID: typebox_1.Type.String({ format: 'uuid' }),
    }),
]);
exports.RFPSkuUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.RFPSkuTransport, ['metadata', 'totalPrice', 'rfpSkuExtras', 'serviceType', 'vendorResponseID', 'rfpID']),
    typebox_1.Type.Object({
        rfpSkuExtras: typebox_1.Type.Optional(typebox_1.Type.Array(rfp_sku_extra_1.RFPSkuExtraUpdate)),
    }),
]));
exports.RFPSkuQuery = typebox_1.Type.Partial(typebox_1.Type.Object({
    limit: typebox_1.Type.Integer(),
    offset: typebox_1.Type.Integer(),
    orderBy: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.Literal('createdAt'), typebox_1.Type.Literal('lastUpdatedAt')])),
    reverseSort: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    vendorResponseID: typebox_1.Type.String({ format: 'uuid' }),
    rfpID: typebox_1.Type.String({ format: 'uuid' }),
    createdBefore: typebox_1.Type.String({ format: 'date-time' }),
    createdAfter: typebox_1.Type.String({ format: 'date-time' }),
}));
//# sourceMappingURL=rfp-sku.js.map